import React from "react";

export default function ProjectVisual({ project, compact = false }) {
  if (project.visual.src) {
    return (
      <div className={`px-visual px-visual-image ${project.visual.kind.startsWith("Local product") ? "px-visual-proof" : ""} ${compact ? "is-compact" : ""}`} style={{ "--project-accent": project.accent }}>
        <img src={project.visual.src} alt={project.visual.alt} />
        <span>{project.visual.kind}</span>
      </div>
    );
  }

  if (project.slug === "voice-agent") {
    return (
      <div className={`px-visual px-voice ${compact ? "is-compact" : ""}`} role="img" aria-label={project.visual.alt} style={{ "--project-accent": project.accent }}>
        <div className="px-voice-status"><i /> GROUNDED RESPONSE</div>
        <div className="px-orb"><span /><span /><span /></div>
        <div className="px-wave" aria-hidden="true">{[15,32,48,26,62,38,75,45,24,58,36,18].map((height,index)=><i key={index} style={{height:`${height}%`}} />)}</div>
        <p>Practice policy found <b>03 sources</b></p>
      </div>
    );
  }

  if (project.slug === "skift") {
    const shifts = [["Maya","10—17"],["Elias","10—16:30"],["Noor","11:30—20"],["Leo","15—22"]];
    return (
      <div className={`px-visual px-skift ${compact ? "is-compact" : ""}`} role="img" aria-label={project.visual.alt} style={{ "--project-accent": project.accent }}>
        <div className="px-skift-top"><span>FRIDAY / GÖTEBORG 01</span><b>Coverage healthy</b></div>
        <div className="px-skift-time"><span>10</span><span>13</span><span>16</span><span>19</span><span>22</span></div>
        {shifts.map((shift,index)=><div className="px-shift" key={shift[0]}><span>{shift[0]}</span><i style={{"--shift-start":index * 9 + "%","--shift-width":58 - index * 4 + "%"}}><b>{shift[1]}</b></i></div>)}
        <div className="px-skift-note">AI DRAFT · MANAGER REVIEW REQUIRED</div>
      </div>
    );
  }

  return (
    <div className={`px-visual px-transcript ${compact ? "is-compact" : ""}`} role="img" aria-label={project.visual.alt} style={{ "--project-accent": project.accent }}>
      <div className="px-transcript-head"><span>CONSULTATION / 04 CHECKS</span><i>LIVE QA</i></div>
      <div className="px-speaker"><b>CL</b><p>What brought you in today?</p></div>
      <div className="px-speaker"><b>PT</b><p>I have had headaches for three days.</p></div>
      <div className="px-checks"><span>OPEN QUESTION <b>YES</b></span><span>EMPATHY <b>YES</b></span><span>SAFETY NET <b className="is-unclear">UNCLEAR</b></span></div>
    </div>
  );
}
